<template>
  <div class="container">
    <div class="survey-title mb40 has-text-centered">What kinds of cannabis <span
        class="highlight-text">products</span> are you interested in?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Select as many as you like.</h3>
      <div class="columns justify-content-center">
        <div class="column">
          <div
            class="field is-grouped is-flex-tablet justify-content-center align-items-center is-flex-wrap">
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Capsules" class="is-checkradio is-block" id="pref-kind-capsules" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-capsules"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-capsule.svg" alt="" class="mb10">
                <h4 class="pref-label">Capsules</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Dried Flower" class="is-checkradio is-block" id="pref-kind-driedflower" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-driedflower"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-driedflower.svg" alt="" class="mb10">
                <h4 class="pref-label">Dried Flower</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Oil Drops" class="is-checkradio is-block" id="pref-kind-oildrops" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-oildrops"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-oildrops.svg" alt="" class="mb10">
                <h4 class="pref-label">Oil Drops</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Oil Sprays" class="is-checkradio is-block" id="pref-kind-oilsprays" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-oilsprays"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-oilsprays.svg" alt="" class="mb10">
                <h4 class="pref-label">Oil Sprays</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Oral Strips" class="is-checkradio is-block" id="pref-kind-oralstrips" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-oralstrips"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-oralstrips.svg" alt="" class="mb10">
                <h4 class="pref-label">Oral Strips</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Pre-rolls" class="is-checkradio is-block" id="pref-kind-prerolls" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-prerolls"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-prerolls.svg" alt="" class="mb10">
                <h4 class="pref-label">Pre-rolls</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="productKind" value="Other" class="is-checkradio is-block" id="pref-kind-other" type="checkbox"
                name="pref-kind">
              <label for="pref-kind-other"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-kind-other.svg" alt="" class="mb10">
                <h4 class="pref-label">Other</h4>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class=""></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()" class="button is-primary ml40 is-marginless-tablet">Next</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a href="#" @click.prevent="setStep(6)" class="is-primary">Skip</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      productKind: [],
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    /**
     * Step back
     */
    back() {
      this.setStep(4);
      this.setSurvey({
        feel: [],
      })
    },

    /**
     * Next step 
     */
    next() {

      if(this.productKind == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please select products are you interested in.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          productKind: this.productKind
        })
        this.setStep(6);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>